import Translator from 'translator/index';
import { Map } from 'immutable';

import SvgTicket from 'data/common/iconsvg/SvgTicket';

export default new Map({
    homesList: {
        key: 0,
        label: Translator.translate('general.ticketsgit'),
        path: 'issues',
        right: 'issuesList',
        Icon: SvgTicket
    }
});



// WEBPACK FOOTER //
// ./environments/ticketsgit/common/subMenuData.js